<script>
import { mapState, mapActions } from 'vuex'

export default {
   data() {
      return {
         // Flag loading untuk menampilkan overlay spinner saat request berjalan.
         loading: false,
      }
   },
   computed: {
      ...mapState({
         kbliPerSektor: state => state.DashboardOss.kbliPerSektor,
         tahun: state => state.DashboardOss.tahun,
         refreshTimestamp: state => state.DashboardOss.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      sektorColors() {
         const colors = [
            '#9f1e15', '#28c76f', '#7367f0', '#ff9f43', '#00cfe8',
            '#ea5455', '#1d4ed8', '#8b5cf6', '#f59e0b', '#10b981',
            '#ec4899', '#14b8a6', '#f97316', '#6366f1', '#84cc16',
            '#06b6d4', '#a855f7', '#ef4444',
         ]
         return colors
      },
      coloredData() {
         return (this.kbliPerSektor.data || [])
            .slice()
            .sort((a, b) => b.total - a.total)
            .map((item, index) => ({
               ...item,
               color: this.sektorColors[index % this.sektorColors.length],
            }))
      },
   },
   watch: {
      tahun(newYear) {
         this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getKbliPerSektor: 'DashboardOss/getKbliPerSektor',
      }),
      async loadData(year) {
         this.loading = true
         try {
            await this.getKbliPerSektor(year)
         } catch (error) {
            // Chart tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
   },
}
</script>

<template>
   <b-overlay
      :show="loading"
      :variant="isDark ? 'dark' : 'white'"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
   >
      <b-row>
         <b-col cols="12">
            <b-card class="card-wrapper">
               <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-1">
                  <div class="mb-1 mb-md-0">
                     <h4 class="mb-25">
                        KBLI per Sektor tahun {{ tahun }}
                     </h4>
                     <small class="text-muted">Distribusi jumlah KBLI berdasarkan sektor</small>
                  </div>
               </div>

               <!-- Table View -->
               <div>
                  <b-table
                     :items="coloredData"
                     :fields="[
                        { key: 'nama', label: 'Sektor' },
                        { key: 'total', label: 'Jumlah KBLI' },
                     ]"
                     responsive
                     class="kbli-table"
                  >
                     <template #cell(nama)="data">
                        <div class="d-flex align-items-center">
                           <span
                              class="sektor-dot mr-1"
                              :style="{ background: data.item.color }"
                           />
                           <span class="text-wrap">{{ data.item.nama }}</span>
                        </div>
                     </template>
                     <template #cell(total)="data">
                        <span class="font-weight-bolder">
                           {{ data.item.total.toLocaleString('id-ID') }}
                        </span>
                     </template>
                  </b-table>
               </div>
            </b-card>
         </b-col>
      </b-row>
   </b-overlay>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.summary-card {
   background: #fff5eb;
   display: inline-block;
   min-width: 120px;
}

.sektor-dot {
   width: 10px;
   height: 10px;
   border-radius: 50%;
   flex-shrink: 0;
}

.kbli-table :deep(.table) {
   margin-bottom: 0;
}

.kbli-table :deep(th) {
   border-top: none;
   font-size: 0.85rem;
   color: #6e6b7b;
}
</style>
